package com.ervasstudio.tracoemovimento.repository

import com.ervasstudio.tracoemovimento.util.AuthState
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.FirebaseAuth
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

object AuthRepository {
    private val auth: FirebaseAuth = Firebase.auth

    private val _state = MutableStateFlow<AuthState>(AuthState.Idle)
    val state: StateFlow<AuthState> = _state.asStateFlow()

    suspend fun signUpWithEmail(nome: String, email: String, password: String) {
        _state.value = AuthState.Loading
        try {
            val result = auth.createUserWithEmailAndPassword(email, password)
            result.user?.updateProfile(displayName = nome)
            _state.value = AuthState.Success(result.user!!.uid, result.user!!.email)
        } catch (e: Exception) {
            _state.value = AuthState.Error(e.message ?: "Erro ao criar conta")
        }
    }

    suspend fun signInWithEmail(email: String, password: String) {
        _state.value = AuthState.Loading
        try {
            val result = auth.signInWithEmailAndPassword(email, password)
            _state.value = AuthState.Success(result.user!!.uid, result.user!!.email)
        } catch (e: Exception) {
            _state.value = AuthState.Error(e.message ?: "Credenciais inválidas")
        }
    }

  /*  suspend fun signInWithGoogle() {
        _state.value = AuthState.Loading
        try {
            val jsAuth = getAuth()
            val provider = GoogleAuthProvider()
            val credential = signInWithPopup(jsAuth, provider).await()
            val user = credential.user
            _state.value = AuthState.Success(user.uid as String, user.email as? String)
        } catch (e: Throwable) {
            _state.value = AuthState.Error(e.message ?: "Falha no login com Google")
        }
    }*/



    suspend fun signOut() {
        auth.signOut()
        _state.value = AuthState.Idle
    }

}